import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LoginStoreEffects } from '@app/root-store/login-store/effects';
import { SelectUserFromNetworkComponent } from '@app/shared/component/select-user-from-network/select-user-from-network.component';
import { CommonService, DocumentService } from '@app/shared/services';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import * as _moment from 'moment';
import { HttpClient } from '@angular/common/http';
import { SharedConfirmationDialogComponent } from '@app/shared/component/shared-confirmation-dialog/shared-confirmation-dialog.component';
import { AnimationOptions } from 'ngx-lottie';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';

const moment = _moment;
export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@AutoUnsubscribe()
@Component({
  selector: 'reminder-creation-form',
  templateUrl: './reminder-creation-form.component.html',
  styleUrls: ['./reminder-creation-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class ReminderCreationFormComponent implements OnInit, OnDestroy {
  inlineComponent = false;
  id;
  animation: AnimationOptions = {
    path: '/assets/lottie/animation-4.json',
  };

  is_loading = true;
  createdBySuggestion = false;
  reminderForm: UntypedFormGroup;
  subscription = new Subscription();
  isCustomAdded = false;
  formValue;
  disabled_fields = {
    action: false,
  };
  triggerTypeList = [];
  ownerUserProfile = {
    id: '',
    name: '',
    image: '',
  };
  loginOwnerUserProfile = {
    id: '',
    name: '',
    image: '',
  };
  is_form_valid = false;
  reminder_object_list = [];

  impersonateUserIdForReport = false;

  triggerTypeOptions = [];

  suggestion_type;
  timeline_period_list = [];

  timeline_period_type_list = [
    { label: 'Days', value: 'day' },
    { label: 'Months', value: 'month' },
    { label: 'Years', value: 'year' },
    { label: 'Quarter', value: 'quarter' },
  ];

  allFinancialAttributeData = [];
  allInsuranceAttributeData = [];
  timeline_type_list = [
    { label: 'Start by Date', value: 'Start by Date' },
    { label: 'Finish by Date', value: 'Finish by Date' },
  ];
  action_list = [
    { label: 'Complete', value: 'complete' },
    { label: 'Review', value: 'review' },
    { label: 'Renew', value: 'renew' },
    { label: 'Locate', value: 'locate' },
    { label: 'Attach', value: 'attach' },
    { label: 'Update', value: 'update' },
    { label: 'Replace', value: 'replace' },
    { label: 'Collect', value: 'collect' },
    { label: 'Other', value: 'other' },
  ];
  status = [
    {
      key: '3',
      value: 'notstarted',
      displayText: 'Not Started',
      className: 'inprogress',
      color: '#2F80ED',
      backgroundColor: 'rgba(47, 128, 237, 0.1)',
    },
    {
      key: '2',
      value: 'inprogress',
      displayText: 'In Progress',
      className: 'notstarted',
      color: '#9B51E0',
      backgroundColor: 'rgba(155, 81, 224, 0.1)',
    },
    { key: '1', value: 'complete', displayText: 'Complete', className: 'complete', color: '#27AE60', backgroundColor: 'rgba(39, 174, 96, 0.1)' },
  ];
  form_id;
  constructor(
    private toastr: ToastrService,
    private formBuilder: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) public data,
    private commonService: CommonService,
    private http: HttpClient,
    private loginService: LoginStoreEffects,
    public dialogRef: MatDialogRef<ReminderCreationFormComponent>,
    private dialog: MatDialog,
    private documentService: DocumentService,
    private cd: ChangeDetectorRef
  ) {}
  ngOnInit(): void {
    this.form_id = this.data.form_id;
    this.suggestion_type = this.data.suggestion_type;
    for (let index = 1; index < 31; index++) {
      this.timeline_period_list.push({
        label: index.toString(),
        value: index.toString(),
      });
    }
    this.subscription.add(
      this.loginService.loginObject.subscribe((state) => {
        if (state?.data?.id && !this.isCustomAdded) {
          this.ownerUserProfile.id = state?.data?.id;
          this.ownerUserProfile.image = state.data.profile_image_url;
          this.ownerUserProfile.name = state?.data.name;
        }
        if (state?.data?.id) {
          this.loginOwnerUserProfile.id = state?.data?.id;
          this.loginOwnerUserProfile.image = state.data.profile_image_url;
          this.loginOwnerUserProfile.name = state?.data.name;
        }
      })
    );

    if (this.data.items) {
      let date = new Date();
      let dateOneAdd = new Date();
      dateOneAdd.setDate(dateOneAdd.getDate() + 1);

      this.id = this.data.items.id;
      this.reminderForm = this.formBuilder.group(
        {
          title: [this.data.items.title, Validators.required],
          sub_title: [],
          owner_user_id: [this.data.items.owner_user_id],
          action: [this.data.items.action, Validators.required],
          reminder_type: [this.data.items.reminder_type ? this.data.items.reminder_type : 'asap', Validators.required],
          start_date: ['ASAP'],
          action_other: [this.data.items.action_other ? this.data.items.action_other : ''],
          timeline_future_date_is: [this.data.items.timeline_future_date_is ? this.data.items.timeline_future_date_is : ''],
          object_description: [this.data.items.object_description, Validators.required],
          object_description_other: [this.data.items.object_description_other],

          timeline_period: [this.data.items.timeline_period ? this.data.items.timeline_period : ''],
          trigger_date: [this.data.items.trigger_date ? this.data.items.trigger_date : ''],
          timeline_period_type: [this.data.items.timeline_period_type ? this.data.items.timeline_period_type : ''],
          timeline_finish_date: [this.data.items.timeline_finish_date ? this.data.items.timeline_finish_date : ''],
          timeline_start_date: [this.data.items.timeline_start_date ? this.data.items.timeline_start_date : ''],
          delay_from_start_date: [this.data.items.delay_from_start_date ? this.data.items.delay_from_start_date : ''],
          delay_from_start_date_period: [this.data.items.delay_from_start_date_period ? this.data.items.delay_from_start_date_period : ''],
          delay_from_start_date_period_type: [
            this.data.items.delay_from_start_date_period_type ? this.data.items.delay_from_start_date_period_type : '',
          ],
          finish_date: ['ASAP'],
          status: [this.data.items.status ? this.data.items.status : 'notstarted'],
        },
        {
          validators: [this.checkReminderFormValidation.bind(this)],
        }
      );
      this.isCustomAdded = true;
      this.ownerUserProfile.id = this.data.items.userid;
      this.ownerUserProfile.image = this.data.items.profile_image_url;
      this.ownerUserProfile.name = this.data.items.first_name + ' ' + this.data.items.last_name;
    } else {
      this.reminderForm = this.formBuilder.group(
        {
          title: ['Untitled Reminder', Validators.required],
          owner_user_id: [''],
          sub_title: [],
          action: ['review', Validators.required],
          action_other: [''],
          reminder_type: ['asap', Validators.required],
          start_date: ['ASAP'],
          object_description: ['', Validators.required],
          finish_date: ['ASAP'],
          timeline_future_date_is: [''],
          timeline_period: [''],
          trigger_date: [''],
          timeline_period_type: [''],
          timeline_start_date: [''],
          timeline_finish_date: [''],
          delay_from_start_date: [''],
          delay_from_start_date_period: [''],
          delay_from_start_date_period_type: [''],
          object_description_other: [''],
          status: ['notstarted'],
        },
        {
          validators: [this.checkReminderFormValidation.bind(this)],
        }
      );
    }
    this.subscription.add(
      this.subscription.add(
        this.documentService.getInsuranceAttribute().subscribe(
          (data) => {
            let key_list = Object.keys(data);
            this.allInsuranceAttributeData = [];
            key_list.forEach((element) => {
              this.allInsuranceAttributeData.push({
                vault_form_code: data[element].vault_form_code,
                title: data[element].title,
              });
            });
            this.subscription.add(
              this.documentService.getFinancialAttribute().subscribe(
                (data) => {
                  let key_list = Object.keys(data);

                  this.allFinancialAttributeData = [];
                  key_list.forEach((element) => {
                    this.allFinancialAttributeData.push({
                      vault_form_code: data[element].vault_form_code,
                      title: data[element].title,
                    });
                  });

                  this.subscription.add(
                    this.documentService.getreminderObjectlist(this.form_id, this.data.currentFormId).subscribe((res) => {
                      this.reminder_object_list = res;
                      this.reminder_object_list.forEach((element) => {
                        if (
                          element.type == 'financial_attributes' &&
                          this.allFinancialAttributeData.findIndex((x) => x.vault_form_code == element.value) >= 0
                        ) {
                          let find_element = this.allFinancialAttributeData.find((x) => x.vault_form_code == element.value);
                          element.label = find_element.title;
                        }
                        if (
                          element.type == 'insurance_attributes' &&
                          this.allInsuranceAttributeData.findIndex((x) => x.vault_form_code == element.value) >= 0
                        ) {
                          let find_element = this.allInsuranceAttributeData.find((x) => x.vault_form_code == element.value);
                          element.label = find_element.title;
                        }
                      });
                      // this.reminder_object_list = this.reminder_object_list.filter(
                      //   (item, index, self) => index === self.findIndex((t) => t.label === item.label)
                      // );
                      this.is_loading = false;
                      this.cd.detectChanges();
                      if (this.data.prePopulateData) {
                        this.setUpPreFillData(this.data.prePopulateData, true);
                      } else {
                        this.addAttribute();
                      }
                      this.cd.detectChanges();
                    })
                  );
                },
                (error) => {
                  console.error(error);
                }
              )
            );
          },
          (error) => {
            console.error(error);
          }
        )
      )
    );

    this.subscription.add(
      this.reminderForm.controls.timeline_future_date_is.valueChanges.subscribe((val) => {
        this.calculateDate();
      })
    );
    this.subscription.add(
      this.reminderForm.controls.delay_from_start_date.valueChanges.subscribe((val) => {
        this.calculateDate();
      })
    );
    this.subscription.add(
      this.reminderForm.controls.delay_from_start_date_period.valueChanges.subscribe((val) => {
        this.calculateDate();
      })
    );
    this.subscription.add(
      this.reminderForm.controls.delay_from_start_date_period_type.valueChanges.subscribe((val) => {
        this.calculateDate();
      })
    );
    this.subscription.add(
      this.reminderForm.controls.timeline_period.valueChanges.subscribe((val) => {
        this.calculateDate();
      })
    );
    this.subscription.add(
      this.reminderForm.controls.timeline_period_type.valueChanges.subscribe((val) => {
        this.calculateDate();
      })
    );
    this.subscription.add(
      this.reminderForm.controls.object_description.valueChanges.subscribe((val) => {
        if (this.reminder_object_list?.length && this.reminder_object_list.findIndex((x) => x.value == val) >= 0) {
          let findObject = this.reminder_object_list.find((x) => x.value == val);
          if (
            !this.reminderForm.controls.title.value.toLowerCase().startsWith('upload ') &&
            (findObject.type == 'insurance_attributes' ||
              findObject.type == 'financial_attributes' ||
              findObject.type == '<Template Name>' ||
              findObject.type == 'attachment' ||
              findObject.type == 'role_players')
          ) {
            if (findObject.type == '<Template Name>') {
              this.reminderForm.controls.timeline_future_date_is.setValue('Start by Date');
              this.reminderForm.controls.reminder_type.setValue('depend');
            } else {
              this.reminderForm.controls.trigger_date.setValue('Last Updated');
              this.reminderForm.controls.timeline_future_date_is.setValue('Start by Date');
              this.reminderForm.controls.reminder_type.setValue('depend');
              if (findObject.max_data) {
                let date = new Date(findObject.max_data);
                this.reminderForm.controls.timeline_start_date.setValue(date);
              } else {
                this.reminderForm.controls.timeline_start_date.setValue('');
              }
            }
          } else {
            if (findObject.type.toLowerCase() == 'other') {
              return;
            }
            if (!this.reminderForm.controls.title.value.toLowerCase().startsWith('upload ')) {
              this.reminderForm.controls.reminder_type.setValue('asap');
              this.reminderForm.controls.trigger_date.setValue('');
              this.reminderForm.controls.timeline_future_date_is.setValue('');
              this.reminderForm.controls.timeline_start_date.setValue('');
            }
          }
          this.calculateDate();
        }
      })
    );

    this.triggerTypeList = this.data.triggerTypeList;
    this.formValue = this.data.formValue.dynamicFieldsForm[0];
    this.triggerTypeOptions = [];
    this.triggerTypeList.forEach((element, index) => {
      let value = this.formValue[element['formControlName']];
      this.triggerTypeOptions.push({
        label: element.label,
        value: element.formControlName,
        is_disable: value === null || value === undefined || value === '' ? true : false,
      });
    });
    this.setUpPreFillData(this.data.prePopulateData);
  }
  findBestMatch(input: string): string {
    const normalizedInput = input.toLowerCase();
    const match = this.timeline_period_type_list.find(
      (periodType) => periodType.label.toLowerCase() === normalizedInput || periodType.value.toLowerCase() === normalizedInput
    );
    return match ? match.value : '';
  }
  getNextDate(inputDateString: string): string {
    // Get the current date and year
    const today = new Date();
    const currentYear = today.getFullYear();

    // Split the input date string into month and day parts
    const [monthString, dayString] = inputDateString.split(' ');
    const day = parseInt(dayString.replace('th', '').replace('st', '').replace('nd', '').replace('rd', ''));

    // Map the month string to a month number (0-based)
    const monthMap: { [key: string]: number } = {
      January: 0,
      February: 1,
      March: 2,
      April: 3,
      May: 4,
      June: 5,
      July: 6,
      August: 7,
      September: 8,
      October: 9,
      November: 10,
      December: 11,
    };
    const month = monthMap[monthString];

    // Create a date object for the parsed month and day in the current year
    let nextDate = new Date(currentYear, month, day);

    // If the date is before today, move to next year
    if (nextDate < today) {
      nextDate.setFullYear(currentYear + 1);
    }

    // Format the date as yyyy/MM/dd
    const formattedNextDate = nextDate.toISOString().split('T')[0].replace(/-/g, '/');

    return formattedNextDate;
  }
  setUpPreFillData(prefillData = null, object_fill = false) {
    try {
      if (prefillData != null) {
        if (prefillData?.length) {
          if (object_fill) {
            try {
              let configurationFieldList = prefillData[0].config[0]['config'];
              let object_config = configurationFieldList.find((x) => x.field.trim().toLowerCase() == 'object');
              let findObjectInTheList =
                this.reminder_object_list.find((x) => x.label.trim().toLowerCase() == object_config.default.toLowerCase()) ??
                this.reminder_object_list.find((x) => x.label.trim().toLowerCase() == 'other');

              if (prefillData[0].title.toLowerCase().includes('update')) {
                findObjectInTheList =
                  this.reminder_object_list.find(
                    (x) => x.label.trim().toLowerCase() === object_config.default.toLowerCase() && x.value.toLowerCase() !== '<template name>'
                  ) ?? this.reminder_object_list.find((x) => x.label.trim().toLowerCase() === 'other');
              }
              if (this.reminder_object_list.find((x) => x.label.trim().toLowerCase() == object_config.default.toLowerCase()) == undefined) {
                this.reminderForm.controls.object_description_other.setValue(object_config.default);
                if (object_config.field_type == 'Fixed') {
                  this.reminderForm.controls.object_description_other.disable();
                  this.reminderForm.controls.object_description.disable();
                }
              }
              if (findObjectInTheList.value) {
                this.reminderForm.controls.object_description.setValue(findObjectInTheList.value);
                if (findObjectInTheList.type.toLowerCase() == 'other') {
                } else if (findObjectInTheList.max_data) {
                  this.reminderForm.controls.timeline_start_date.setValue(findObjectInTheList.max_data);
                } else {
                  if (!this.reminderForm.controls.title.value.toLowerCase().startsWith('upload ')) {
                    this.reminderForm.controls.timeline_start_date.setValue('');
                  }
                }
              }
              if (object_fill) {
                this.addAttribute();
              }
            } catch (error) {}
          } else {
            this.reminderForm.controls.reminder_type.setValue(prefillData[0].reminder_type == 'Trigger' ? 'depend' : 'future');
            this.reminderForm.controls.title.setValue(prefillData[0].display_text?.trim());
            this.reminderForm.controls.sub_title.setValue(prefillData[0].display_subtext?.trim());

            this.createdBySuggestion = true;
            try {
              let configurationFieldList = prefillData[0].config[0]['config'];
              configurationFieldList.forEach((element, index) => {
                if (this.isNotNullEmpty(element.default)) {
                } else if (element.field.trim() == 'Owner') {
                } else if (element.field.trim() == 'Action') {
                  this.reminderForm.controls.action.setValue(element.default.toLowerCase());
                  if (element.field_type == 'Fixed') {
                    this.disabled_fields.action = true;
                  }
                } else if (element.field.trim() == 'Object') {
                  this.reminderForm.controls.object_description.setValue(element.default.toLowerCase());
                  if (element.field_type == 'Fixed') {
                    this.reminderForm.controls.object_description.disable();
                  }
                } else if (element.field.trim() == 'Schedule') {
                } else if (element.field.trim() == 'Delay') {
                  if (element.default == 'Off') {
                    return;
                  }
                  try {
                    let defaultValue = this.parseInput(element.default);
                    this.reminderForm.controls.delay_from_start_date_period.setValue(defaultValue?.value ? defaultValue?.value.toString() : '');
                    this.reminderForm.controls.delay_from_start_date_period_type.setValue(this.findBestMatch(defaultValue.unit));
                    this.reminderForm.controls.delay_from_start_date.setValue(true);
                  } catch (error) {
                    console.error('*** Delay ***', error);
                  }
                } else if (element.field.trim() == 'Time To Complete') {
                  if (element.default == 'Off') {
                    return;
                  }

                  try {
                    let defaultValue = this.parseInput(element.default);
                    this.reminderForm.controls.timeline_period.setValue(defaultValue?.value ? defaultValue?.value.toString() : '');
                    this.reminderForm.controls.timeline_period_type.setValue(this.findBestMatch(defaultValue.unit));
                  } catch (error) {
                    console.error('*** Time To Complete ***', error);
                  }
                } else if (element.field.trim() == 'Trigger Date') {
                  let default_value: string = element.default.replace(/[<>]/g, '');
                  this.triggerTypeOptions.forEach((element) => {
                    if (element.label.toLowerCase() == default_value.toLowerCase()) {
                      if (element.is_disable == false) {
                        this.reminderForm.controls.trigger_date.setValue(element.value);
                      }
                    }
                  });
                  if (element.field_type == 'Fixed') {
                    this.reminderForm.controls.trigger_date.disable();
                  }
                } else if (element.field.trim() == 'Start') {
                  try {
                    if (element.default == 'Auto-populated') {
                      this.reminderForm.controls.timeline_future_date_is.setValue('Finish by Date');
                      let nextDate = new Date(this.formValue[this.reminderForm.controls.trigger_date.value]);
                      if ((nextDate as any) != 'Invalid Date') {
                        this.reminderForm.controls.timeline_finish_date.setValue(nextDate);
                      }
                      if (element.field_type == 'Fixed') {
                        this.reminderForm.controls.timeline_finish_date.disable();
                      }
                    } else {
                      if (configurationFieldList.findIndex((x) => x.default == '<Today>') > 0) {
                        this.reminderForm.controls.trigger_date.setValue('Last Updated');
                        let outputData_value = new Date();
                        if (this.reminderForm.controls.timeline_future_date_is.value == 'Finish by Date') {
                          this.reminderForm.controls.timeline_finish_date.setValue(outputData_value);
                        }
                        if (this.reminderForm.controls.timeline_future_date_is.value == 'Start by Date') {
                          this.reminderForm.controls.timeline_start_date.setValue(outputData_value);
                        }
                      } else {
                        let outputData = this.getNextDate(element.default);
                        let outputData_value = new Date(outputData);
                        if (this.reminderForm.controls.timeline_future_date_is.value == 'Finish by Date') {
                          this.reminderForm.controls.timeline_finish_date.setValue(outputData_value);
                        }
                        if (this.reminderForm.controls.timeline_future_date_is.value == 'Start by Date') {
                          this.reminderForm.controls.timeline_start_date.setValue(outputData_value);
                        }
                      }
                    }

                    this.calculateDate();
                  } catch (error) {
                    console.error('*** Start ***', error);
                  }
                } else if (element.field.trim() == 'Finish') {
                  try {
                    if (element.default == 'Auto-populated') {
                      this.reminderForm.controls.timeline_future_date_is.setValue('Start by Date');
                      let nextDate = new Date(this.formValue[this.reminderForm.controls.trigger_date.value]);
                      if ((nextDate as any) != 'Invalid Date') {
                        this.reminderForm.controls.timeline_start_date.setValue(nextDate);
                      }
                    }

                    this.calculateDate();
                  } catch (error) {
                    console.error('*** Start ***', error);
                  }
                } else if (element.field.trim() == 'Future Date Is') {
                  if (element.default.trim() == 'Finish by Date') {
                    this.reminderForm.controls.timeline_future_date_is.setValue('Finish by Date');
                  }
                  if (element.default.trim() == 'Start by Date') {
                    this.reminderForm.controls.timeline_future_date_is.setValue('Start by Date');
                  }
                  if (element.field_type == 'Fixed') {
                    this.reminderForm.controls.timeline_future_date_is.disable();
                  }

                  this.calculateDate();
                } else if (element.field.trim() == 'Trigger Date Is') {
                  if (element.default.trim() == 'Finish Date') {
                    this.reminderForm.controls.timeline_future_date_is.setValue('Finish by Date');
                  }
                  if (element.default.trim() == 'Start Date') {
                    this.reminderForm.controls.timeline_future_date_is.setValue('Start by Date');
                  }
                  if (element.field_type == 'Fixed') {
                    this.reminderForm.controls.timeline_future_date_is.disable();
                  }

                  this.calculateDate();
                }
              });
              this.reminderForm.updateValueAndValidity();
              if (object_fill) {
                this.addAttribute();
              }
            } catch (error) {}
          }
        }
      }
    } catch (error) {
      console.error('* error *', error);
    }
  }
  parseInput(input: string): { value: number; unit: string } {
    const [value, unit] = input.split(/\/|\s+/);
    return { value: parseFloat(value), unit: unit.trim() };
  }
  isNotNullEmpty(value) {
    if (value == null || value == undefined || value == '') {
      return true;
    } else {
      return false;
    }
  }
  checkReminderFormValidation(formGroup: UntypedFormGroup) {
    let data_object = {
      title: formGroup.controls.title.value,
      owner_user_id: formGroup.controls.owner_user_id.value,
      action: formGroup.controls.action.value,
      action_other: formGroup.controls.action_other.value,
      reminder_type: formGroup.controls.reminder_type.value,
      start_date: formGroup.controls.start_date.value,
      object_description: formGroup.controls.object_description.value,
      finish_date: formGroup.controls.finish_date.value,
      timeline_future_date_is: formGroup.controls.timeline_future_date_is.value,
      timeline_period: formGroup.controls.timeline_period.value,
      trigger_date: formGroup.controls.trigger_date.value,
      timeline_period_type: formGroup.controls.timeline_period_type.value,
      timeline_start_date: formGroup.controls.timeline_start_date.value,
      timeline_finish_date: formGroup.controls.timeline_finish_date.value,
      status: formGroup.controls.status.value,
      delay_from_start_date_period_type: formGroup.controls.delay_from_start_date_period_type.value,
      delay_from_start_date_period: formGroup.controls.delay_from_start_date_period.value,
      delay_from_start_date: formGroup.controls.delay_from_start_date.value,
      object_description_other: formGroup.controls.object_description_other.value,
    };

    if (
      !this.isNotNullEmpty(data_object['object_description']) &&
      data_object['object_description'] == 'Other' &&
      this.isNotNullEmpty(data_object['object_description_other'])
    ) {
      this.is_form_valid = false;
    } else if (this.isNotNullEmpty(data_object['object_description']) || this.isNotNullEmpty(data_object['title'])) {
      this.is_form_valid = false;
    } else {
      if (data_object['reminder_type'] == 'asap') {
        this.is_form_valid = true;
      } else if (data_object['reminder_type'] == 'future') {
        if (
          this.isNotNullEmpty(data_object['timeline_finish_date']) ||
          this.isNotNullEmpty(data_object['timeline_start_date']) ||
          this.isNotNullEmpty(data_object['timeline_future_date_is']) ||
          this.isNotNullEmpty(data_object['timeline_period']) ||
          this.isNotNullEmpty(data_object['timeline_period_type'])
        ) {
          this.is_form_valid = false;
        } else {
          this.is_form_valid = true;
        }
      } else if (data_object['reminder_type'] == 'depend') {
        if (
          this.isNotNullEmpty(data_object['trigger_date']) ||
          this.isNotNullEmpty(data_object['timeline_finish_date']) ||
          this.isNotNullEmpty(data_object['timeline_start_date']) ||
          this.isNotNullEmpty(data_object['timeline_future_date_is']) ||
          this.isNotNullEmpty(data_object['timeline_period']) ||
          this.isNotNullEmpty(data_object['timeline_period_type'])
        ) {
          this.is_form_valid = false;
        } else {
          if (data_object['delay_from_start_date'] && data_object['timeline_future_date_is'] == 'Start by Date') {
            if (
              this.isNotNullEmpty(data_object['delay_from_start_date_period']) ||
              this.isNotNullEmpty(data_object['delay_from_start_date_period_type'])
            ) {
              this.is_form_valid = false;
            } else {
              this.is_form_valid = true;
            }
          } else {
            this.is_form_valid = true;
          }
        }
      }
    }
    return null;
  }
  addEvent(event, value) {
    this.calculateDate();
  }
  calculateDate() {
    if (
      (this.reminderForm.controls.timeline_start_date.value != '' || this.reminderForm.controls.timeline_finish_date.value != '') &&
      this.reminderForm.controls.timeline_period_type.value != '' &&
      this.reminderForm.controls.timeline_period.value != ''
    ) {
      if (this.reminderForm.controls.timeline_future_date_is.value == 'Start by Date') {
        let timeline_start_date = this.reminderForm.controls.timeline_start_date.value;
        if (
          this.reminderForm.controls.delay_from_start_date.value &&
          this.reminderForm.controls.delay_from_start_date_period.value &&
          this.reminderForm.controls.delay_from_start_date_period_type.value
        ) {
          timeline_start_date = this.commonService.calculateNextDate(
            timeline_start_date,
            this.reminderForm.controls.delay_from_start_date_period.value,
            this.reminderForm.controls.delay_from_start_date_period_type.value,
            true
          );
        }
        let nextDate = this.commonService.calculateNextDate(
          timeline_start_date,
          this.reminderForm.controls.timeline_period.value,
          this.reminderForm.controls.timeline_period_type.value,
          true
        );
        if ((nextDate as any) != 'Invalid Date') {
          this.reminderForm.controls.timeline_finish_date.setValue(nextDate);
        }
      } else {
        let nextDate = this.commonService.calculateNextDate(
          this.reminderForm.controls.timeline_finish_date.value,
          this.reminderForm.controls.timeline_period.value,
          this.reminderForm.controls.timeline_period_type.value,
          false
        );
        if ((nextDate as any) != 'Invalid Date') {
          this.reminderForm.controls.timeline_start_date.setValue(nextDate);
        }
      }
    }
    this.cd.detectChanges();
  }
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  openAddOwnerUser() {
    const modalRef3 = this.dialog.open(SelectUserFromNetworkComponent, {
      panelClass: 'full-window-dialog-2',
      autoFocus: false,
      disableClose: false,
      data: {
        currentFormId: this.data.currentFormId,
        loginOwnerUserProfile: this.loginOwnerUserProfile,
        impersonateUserIdForReport: this.impersonateUserIdForReport,
      },
    });
    this.subscription.add(
      modalRef3.afterClosed().subscribe((res) => {
        if (res.isSuccess) {
          this.isCustomAdded = true;
          this.ownerUserProfile = res.item;
          this.cd.detectChanges();
        }
      })
    );
  }

  setReminderType(type) {
    if (this.createdBySuggestion) {
      return;
    }
    if (this.reminderForm.controls.reminder_type.value == type) {
      return;
    }
    this.reminderForm.controls.reminder_type.setValue(type);
    if (type == 'depend' || type == 'future') {
      this.reminderForm.controls.timeline_future_date_is.setValue('');
      this.reminderForm.controls.timeline_start_date.setValue('');
      this.reminderForm.controls.timeline_period.setValue('');
      this.reminderForm.controls.timeline_finish_date.setValue('');
      this.reminderForm.controls.timeline_period_type.setValue('');
    }

    this.cd.detectChanges();
  }
  addAttribute() {
    if (!this.reminderForm.valid || !this.is_form_valid) {
      return;
    }
    let data_object = {
      title: this.reminderForm.controls.title.value,
      suggestion_type: this.suggestion_type,
      sub_title: this.reminderForm.controls.sub_title.value,
      owner_user_id: this.reminderForm.controls.owner_user_id.value,
      action: this.reminderForm.controls.action.value,
      action_other: this.reminderForm.controls.action_other.value,
      reminder_type: this.reminderForm.controls.reminder_type.value,
      start_date: this.reminderForm.controls.start_date.value,
      object_description: this.reminderForm.controls.object_description.value,
      finish_date: this.reminderForm.controls.finish_date.value,
      timeline_future_date_is: this.reminderForm.controls.timeline_future_date_is.value,
      timeline_period: this.reminderForm.controls.timeline_period.value,
      trigger_date: this.reminderForm.controls.trigger_date.value,
      timeline_period_type: this.reminderForm.controls.timeline_period_type.value,
      timeline_start_date: this.reminderForm.controls.timeline_start_date.value,
      timeline_finish_date: this.reminderForm.controls.timeline_finish_date.value,
      status: this.reminderForm.controls.status.value,
      delay_from_start_date_period_type: this.reminderForm.controls.delay_from_start_date_period_type.value,
      delay_from_start_date_period: this.reminderForm.controls.delay_from_start_date_period.value,
      delay_from_start_date: this.reminderForm.controls.delay_from_start_date.value,
      object_description_other: this.reminderForm.controls.object_description_other.value,
    };

    let data = {
      vault_user_form_id: this.data.currentFormId,
      ...data_object,
      start_date: this.reminderForm.controls.start_date.value,
      timeline_start_date: this.reminderForm.controls.timeline_start_date.value,
      timeline_finish_date: this.reminderForm.controls.timeline_finish_date.value,
      finish_date: this.reminderForm.controls.finish_date.value,
      updated_by: this.loginOwnerUserProfile.id,
    };
    data['owner_user_id'] = this.ownerUserProfile.id;

    if (data['object_description'] != 'Other') {
      delete data['object_description_other'];
    }
    if (this.reminderForm.controls.reminder_type.value == 'asap') {
      delete data['timeline_future_date_is'];
      delete data['timeline_period'];
      delete data['timeline_period_type'];
      delete data['timeline_start_date'];
      delete data['timeline_finish_date'];
      delete data['delay_from_start_date'];
      delete data['delay_from_start_date_period'];
      delete data['delay_from_start_date_period_type'];
    } else if (this.reminderForm.controls.reminder_type.value == 'future') {
      delete data['start_date'];
      delete data['finish_date'];
      delete data['trigger_date'];
      delete data['delay_from_start_date'];
      delete data['delay_from_start_date_period'];
      delete data['delay_from_start_date_period_type'];
    } else {
      delete data['start_date'];
      delete data['finish_date'];
      if (
        data['delay_from_start_date'] == false ||
        data['delay_from_start_date'] == null ||
        data['delay_from_start_date'] == undefined ||
        data['delay_from_start_date'] == ''
      ) {
        delete data['delay_from_start_date_period'];
        delete data['delay_from_start_date_period_type'];
      }
      data['delay_from_start_date'] = data['delay_from_start_date'] == true ? 1 : 0;
    }
    if (this.reminderForm.controls.timeline_future_date_is.value != 'Start by Date') {
      try {
        delete data['delay_from_start_date'];
        delete data['delay_from_start_date_period'];
        delete data['delay_from_start_date_period_type'];
      } catch (error) {}
    }
    if (data['timeline_finish_date']) {
      let date = new Date(data['timeline_finish_date']);

      // Extract the year, month, and day
      let year = date.getFullYear();
      let month = ('0' + (date.getMonth() + 1)).slice(-2); // Months are 0-based, so add 1
      let day = ('0' + date.getDate()).slice(-2);

      // Format the date as 'YYYY-MM-DD'
      data['timeline_finish_date'] = `${year}-${month}-${day}`;
    }
    if (data['timeline_start_date']) {
      let date = new Date(data['timeline_start_date']);

      // Extract the year, month, and day
      let year = date.getFullYear();
      let month = ('0' + (date.getMonth() + 1)).slice(-2); // Months are 0-based, so add 1
      let day = ('0' + date.getDate()).slice(-2);

      // Format the date as 'YYYY-MM-DD'
      data['timeline_start_date'] = `${year}-${month}-${day}`;
    }
    if (this.id) {
      data['id'] = this.id;
      this.subscription.add(
        this.documentService.updateReminder(data).subscribe(
          (res) => {
            this.toastr.success('Reminder Updated  successfully.');
            this.closeDialog();
          },
          (error) => {
            this.toastr.error(error);
          }
        )
      );
    } else {
      this.subscription.add(
        this.documentService.addReminder(data).subscribe(
          (res) => {
            this.toastr.success('Reminder Added successfully.');
            this.closeDialog();
          },
          (error) => {
            this.toastr.error(error);
          }
        )
      );
    }
  }
  closeDialogReminder() {
    if (this.id) {
      this.closeDialog();
    } else {
      const sharedDialogRef = this.dialog.open(SharedConfirmationDialogComponent, {
        width: '500px',
        data: {
          title: 'Exit Reminders',
          materialIcon: 'info',
          text: `Are you sure you want to exit without saving the ‘${this.reminderForm.controls.title.value}’?`,
          proceedTitle: 'Exit',
          showCancelBtn: true,
        },
      });

      this.subscription.add(
        sharedDialogRef.afterClosed().subscribe((res) => {
          if (res.confirmation) {
            this.closeDialog();
          }
          this.cd.detectChanges();
        })
      );
    }
  }
  closeDialog() {
    this.dialogRef.close();
  }
}
